import restApi from "@plannel/services/utils/rest-api";

const getAll = (params) => {
  return restApi.post("/api/postn", params);
};

const getPostnByUser = (params) => {
  return restApi.get("/api/postn/user", { params });
};

const getClrs = (params) => {
  return restApi.get("/api/postnclsr", { params });
};

const getParentChildClrs = (params) => {
  return restApi.get("/api/postn/child", { params });
};

const getChildClsr = (params) => {
  return restApi.post("/api/postn/childclsr", params );
};

const getAllForCSV = params => {
  return restApi.post("/api/postn", params);
};

const get = id => {
  return restApi.get(`/api/postn/${id}`);
};

const upsert = data => {
  return restApi.post("/api/postn/save", data);
};

const remove = ids => {
  return restApi.delete(`/api/postn/${ids}`);
};

const confirm = params => {
  return restApi.post("/api/postn/confirm", params);
};

const cancel = params => {
  return restApi.post("/api/postn/cancel", params);
};

const postnService = {
  getAll,
  getPostnByUser,
  getClrs,
  getParentChildClrs,
  getChildClsr,
  getAllForCSV,
  get,
  upsert,
  remove,
  confirm,
  cancel
};

export default postnService;